import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="bg-[#0D0D0D] text-white py-16 md:py-24 px-4 relative overflow-hidden" data-id="element-55">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#F5C518] opacity-5 blur-[120px] rounded-full pointer-events-none" data-id="element-56"></div>

      <div className="max-w-4xl mx-auto flex flex-col items-center text-center relative z-10" data-id="element-57">
        <h1 className="font-montserrat font-black text-4xl md:text-5xl lg:text-6xl leading-tight mb-6 text-white uppercase" data-id="element-58">
          CÓMO QUEMAR GRASA SIN DEJAR DE COMER RICO:{' '}
          <span className="text-[#F5C518]" data-id="element-59">
            EL SISTEMA KETO CRIOLLO PARA EL COLOMBIANO OCUPADO
          </span>
        </h1>

        <h2 className="font-inter font-medium text-lg md:text-2xl text-gray-300 mb-10 max-w-3xl leading-relaxed" data-id="element-60">
          Baja de peso en 7 días usando solo lo que encuentras en el D1, el Ara
          o la tienda de tu barrio (sin dietas caras de revista).
        </h2>

        <div className="relative w-full max-w-[500px] mb-12 group" data-id="element-61">
          <div className="absolute inset-0 bg-[#F5C518] opacity-20 blur-2xl rounded-full group-hover:opacity-30 transition-opacity duration-500" data-id="element-62"></div>
          <img src="https://cdn.magicpatterns.com/uploads/poVndQCCLVksN26baVVmDB/heylloyd-image-1772327665560.png" alt="Menú Exprés: 7 Días Keto Colombiano" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl transform transition-transform duration-500 hover:scale-[1.02]" data-id="element-63" />
        </div>

        <CTAButton data-id="element-64" />

        <p className="mt-4 font-inter text-sm text-gray-400 flex items-center gap-2" data-id="element-65">
          <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-66"></span>
          Acceso inmediato • Pago 100% seguro
        </p>
      </div>
    </section>;
}